import { Box, useTheme } from "@mui/material";
import React from "react";

const SocialMediaIconWrapper = ({ children }) => {
  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          padding: 2,
          width: 4,
          height: 4,
          borderRadius: "50%",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          border: `1px solid ${theme.palette.primary.main}`,
        }}
      >
        {children}
      </Box>
    </>
  );
};

export default SocialMediaIconWrapper;
